<template>
  <div>

    <h2 class="mb-3 text-dark" v-if="card.punches_used > 0" id="usedPunches">Nyttjade ({{ card.punches_used }})</h2>

    <div class="list" :class="{ 'd-none' : fetcher.initialized }">
        <div class="list-item treatment" :key="'lit'+i" v-for="i in card.punches_used">
          <div class="d-flex">
            <div class="list-icon">
              <div class="ratio ratio-1x1">
                <div>
                  <div class="icon check"><img
                    src="/images/card/card-used-check-icon-dark.svg"></div>
                </div>
              </div>
            </div>
            <div class="placeholder-glow" style="width:calc(100% - 50px); height: 45px;">
                <div class="placeholder bg-info w-50 rounded-1" style="height: 18px; margin:0;"></div>
                <div class="placeholder bg-info w-75 rounded-1" style="height: 16px; margin:0;"></div>
            </div>
          </div>

        </div>
    </div>

    <div v-if="fetcher.initialized">

      <transition-group class="list" name="used-treatment-list" tag="div">

        <div class="list-item treatment" :key="'utreatment'+index"
             v-for="(treatment, index) in used_treatments">
          <div class="d-flex">
            <div class="list-icon">
              <div class="ratio ratio-1x1">
                <div>
                  <div class="icon check"><img
                    src="/images/card/card-used-check-icon-dark.svg"></div>
                </div>
              </div>
            </div>
            <div style="width:calc(100% - 50px); min-height: 45px;">
              <h4 class="text-dark">{{ niceTreatmentAt(treatment.created_at) }} </h4>
              <p>

                <router-link tag="span" class="clinic-link" :to="{name: 'card-clinic', params: {clinic: treatment.clinic_id }}">
                  <img src="/images/card/clinic-location-icon.svg">
                  {{ treatment.cardTreatmentLocation }}
                </router-link>

              </p>
            </div>
          </div>

        </div>

      </transition-group>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import fetcher from '../../../shared/mixins/fetcher'

export default {

    mixins: [
        fetcher
    ],

    props: {
        card: {
            required: true
        }
    },

    data () {
        return {
            used_treatments: [],
            fetcher: {
                autoFill: [
                    'used_treatments'
                ]
            },

            registerModalVisible: false,
            clinicModalVisible: false
        }
    },
    computed: {
        fetcherUrl () {
            return '/cards/' + this.card.id + '/treatments'
        }
    },

    methods: {
        niceTreatmentAt (treatment_at) {
            return moment(treatment_at).locale('sv').format('D MMM YYYY')
        }
    }
}
</script>
<style type="text/css">
.used-treatment-list-enter-active, .used-treatment-list-leave-active
{
    transition:margin 750ms ease, padding 750ms ease, max-height 750ms ease, transform 1000ms ease;
    overflow: hidden;
}
.used-treatment-list-enter,
.used-treatment-list-leave-to {
  max-height: 0px;
  margin:0;
  padding:0;
  transform: scale(1,0);
}
.used-treatment-list-enter-to,
.used-treatment-list-leave {
  max-height: 120px;
}
</style>
